export default "__VITE_ASSET__pC4bA7jb__"